<template>
    <loader v-if="loading" />
    <v-row v-else class="accounts-view">
        <v-col cols="12">
            <v-card>
                <v-subheader>
                    <v-col v-for="(header, index) in headers" :key="index" :cols="header.cols" class="d-flex pa-0 ma-0" :class="header.class">
                        {{ header.text }}
                    </v-col>
                </v-subheader>
                <v-list dense subheader class="striped-list">
                    <v-list-item>
                        <v-list-item-content>
                            <v-row no-gutters align="center">
                                <v-col :cols="headers[0].cols" class="d-flex" :class="headers[0].class">
                                    <div :style="'width: ' + headers[0].wrapperWidth">
                                        <v-text-field v-model="newAccount.name" />
                                    </div>
                                </v-col>
                                <v-col :cols="headers[1].cols" class="d-flex" :class="headers[1].class">
                                    <div :style="'width: ' + headers[1].wrapperWidth">
                                        <v-text-field v-model="newAccount.username" />
                                    </div>
                                </v-col>
                                <v-col :cols="headers[2].cols" class="d-flex" :class="headers[2].class">
                                    <div :style="'width: ' + headers[2].wrapperWidth">
                                        <v-select v-model="newAccount.access" :items="accessOptions" />
                                    </div>
                                </v-col>
                                <v-col :cols="headers[3].cols" class="d-flex" :class="headers[3].class">
                                    <div :style="'width: ' + headers[3].wrapperWidth">
                                        <v-text-field v-model="newAccount.password" />
                                    </div>
                                </v-col>
                                <v-col :cols="headers[4].cols" class="d-flex" :class="headers[4].class">
                                </v-col>
                                <v-col :cols="headers[5].cols" class="d-flex" :class="headers[5].class">
                                    <v-btn color="green" dark @click="createAccount">
                                        Ny konto
                                        <v-icon right>
                                            fa-plus
                                        </v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-for="(account, index) in accounts" :key="index">
                        <v-list-item-content>
                            <v-row no-gutters align="center">
                                <v-col :cols="headers[0].cols" class="d-flex" :class="headers[0].class">
                                    <div :style="'width: ' + headers[0].wrapperWidth">
                                        <v-text-field v-model="account.name" />
                                    </div>
                                </v-col>
                                <v-col :cols="headers[1].cols" class="d-flex" :class="headers[1].class">
                                    <div :style="'width: ' + headers[1].wrapperWidth">
                                        <v-text-field v-model="account.username" />
                                    </div>
                                </v-col>
                                <v-col :cols="headers[2].cols" class="d-flex" :class="headers[2].class">
                                    <div :style="'width: ' + headers[2].wrapperWidth">
                                        <v-select v-model="account.access" :items="accessOptions" />
                                    </div>
                                </v-col>
                                <v-col :cols="headers[3].cols" class="d-flex" :class="headers[3].class">
                                    <div :style="'width: ' + headers[3].wrapperWidth">
                                        <v-text-field type="password" v-model="account.password" />
                                    </div>
                                </v-col>
                                <v-col :cols="headers[4].cols" class="d-flex" :class="headers[4].class">
                                    <v-btn color="primary" @click="updateAccount(account)" depressed>
                                        Opdater konto
                                        <v-icon right>
                                            fa-save
                                        </v-icon>
                                    </v-btn>
                                </v-col>
                                <v-col :cols="headers[5].cols" class="d-flex" :class="headers[5].class">
                                    <v-btn color="red" dark @click="deleteAccount(account, index)" depressed>
                                        Slet konto
                                        <v-icon right>
                                            fa-trash-alt
                                        </v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import stringHash from 'string-hash'

export default {
    data () {
        return {
            loading: false,
            accounts: null,
            newAccount: {},
            headers: [
                {
                    text: 'Navn',
                    cols: 2,
                    wrapperWidth: '95%',
                    class: 'justify-start'
                },
                {
                    text: 'Brugernavn',
                    cols: 2,
                    wrapperWidth: '50%',
                    class: 'justify-center'
                },
                {
                    text: 'Adgang',
                    cols: 2,
                    wrapperWidth: '50%',
                    class: 'justify-center'
                },
                {
                    text: 'Password',
                    cols: 2,
                    wrapperWidth: '50%',
                    class: 'justify-center'
                },
                {
                    text: '',
                    cols: 2,
                    wrapperWidth: '50%',
                    class: 'justify-center'
                },
                {
                    text: '',
                    cols: 2,
                    wrapperWidth: '100%',
                    class: 'justify-end'
                }
            ],
            accessOptions: [
                'admin',
                'all',
                'booker',
                'tele',
                'booking',
                'naestved',
                'fh',
                'pii'
            ]
        }
    },
    methods: {
        async getData () {
            this.loading = true
            let response = await this.$http().get('/controlpanel/accounts')
            this.accounts = response.data
            this.loading = false
        },
        async createAccount() {
            const response = await this.$http().post('/controlpanel/account', {
                ...this.newAccount,
                password: stringHash(this.newAccount.password)
            })
            if (response.status === 200) this.accounts.push(this.newAccount)
            this.newAccount = {}
        },
        async updateAccount(account) {
            if (account.password) account.password = stringHash(account.password)
            await this.$http().patch('/controlpanel/account', account)
        },
        async deleteAccount(account, index) {
            const response = await this.$http().delete(`/controlpanel/account/${account.id}`)
            if (response.status === 200) this.accounts.splice(index, 1)
        }
    },
    created () {
        this.getData()
    }
}
</script>